export default {
  delete_success: 'Tilbuddet er slettet',
  delete_failed: 'Tilbuddet kunne ikke slettes',
  delete_confirm_title: 'Er du sikker på, at du vil slette dette tilbud?',
  delete_last_day_confirm_title: 'Hvis du fjerner den sidste dag, slettes dette tilbud. Er du sikker?',
  confirm: 'Bekræft',
  cancel: 'Annuller',
  qualifying_items: 'Kvalificerende varer',
  free_items: 'Gratis varer',
  all_day: 'Hele dagen',
  starts_on: 'Starter den {{date}}',
  ends_on: 'Slutter den {{date}}',
  ends_when_deleted: 'Slutter, når det slettes',
  off: '{{amount}} rabat',
  min_spend_value: 'Min. forbrug: {{amount}}',
};
